import groq from 'groq'

export const allEmployeeInfoGroq = groq`
*[_type == "employee" && isPublished]{
    _id,
    name,
    "educationalDegree":educationalDegree.[$language],
    "avatar": {
      "alt": employeeAvatar.alt,
      "srcKey": employeeAvatar.srcKey
    },
    "description":description.[$language],
    "jobTitle": jobTitle.[$language],
    "categories": categories[]->{id, "category": category.[$language]},
    educations[]{
      _key,
      "degree": degree.[$language],
      "institute": educationalInstitute.[$language]
    },
    "employeeOrder": employeeOrder[]{
      "subCategory": subCategories->name,
      "orderOfSubCategory": subCategories->priority,
      "employeeOrderInSubCategory": priority
    }
}
`
export const EmployeeCategoriesGroq = groq`
 *[_type == "employeeCategories"] | order(_createdAt asc) {id, "category": category.[$language]}
`
